<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title appLifecycleTracker trackerName="reparent-dialog">{{'ADM_REPARENT' | translate}}</h2>

<mat-dialog-content>
    <mat-form-field class="user-selection" appearance="outline">
        <mat-label>{{'ADU_GROUP' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedGroup" (selectionChange)="onSelectedGroupChanged()">
            <mat-option *ngFor="let group of groups" [value]="group">{{ group.name }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="user-selection" appearance="outline">
        <mat-label>{{'ADM_NEW_PARENT_GROUP' | translate}}</mat-label>
        <mat-select [(ngModel)]="selectedParentGroup">
            <mat-option *ngFor="let group of parentGroups" [value]="group">{{ group.name }}</mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClose()" type="button">{{'CANCEL' | translate}}</button>
    <button mat-raised-button (click)="onSubmit()" type="button" color="primary">{{'SAVE' | translate}}</button>
</div>
